import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createRegistration = (payload) => axios.post(`${API}/registrations`, payload, { timeout: 15000 });

export const createApplication = (payload) => axios.post(`${API}/applications`, payload, { timeout: 15000 });

export const createContactMessage = (payload) => axios.post(`${API}/contact`, payload, { timeout: 15000 });
